<template>
<div>
    <div class="index">
      <pic-news :plates="plates"/>
      <div  class="container">
        <img src="/static/img/o1_shouye1.png" class="centerimg" style="margin-right:27px;"/>
        <img src="/static/img/o1_shouye2.png" class="centerimg" style="margin-right:27px;"/>
        <img src="/static/img/o1_shouye3.png" class="centerimg"/>
      </div>
      <!-- <left-news :plates="plates" /> -->
      <a :href="ggw1picsrc.url"> <img v-if="ggw1picsrc" class="advimg" :src="`${global.remoteIp}/uploads/${ggw1picsrc.picsrc}`" /></a>
      <middle-news :plates="plates"/>
      
       <a :href="ggw2picsrc.url"> <img v-if="ggw2picsrc" class="advimg" :src="`${global.remoteIp}/uploads/${ggw2picsrc.picsrc}`" /></a>
      <!-- <mid-pic-news :plates="plates"></mid-pic-news> -->
      <bottom-news :plates="plates"></bottom-news>
      <mid-pic-news :plates="plates"></mid-pic-news>
       <a :href="ggw3picsrc.url"> <img v-if="ggw3picsrc" class="advimg" :src="`${global.remoteIp}/uploads/${ggw3picsrc.picsrc}`" /></a>
    </div>
  <web-links />
</div>  
</template>
<script>
import BottomNews from "../components/HomeComs/BottomNews.vue";
import FootInfo from "../components/HomeComs/FootInfo.vue";
import LeftNews from "../components/HomeComs/leftNews.vue";
import MiddleNews from "../components/HomeComs/MiddleNews.vue";
import WebLinks from "../components/HomeComs/WebLinks.vue";
import global from "@/components/PublicComs/Common.vue";
import MidPicNews from "../components/HomeComs/MidPicNews.vue";
import RightNews from "../components/HomeComs/RightNews.vue";
import PicNews from "../components/HomeComs/PicNews.vue"
const rate= window.innerWidth/1240;
export default {
  name: "home",
  metaInfo: {
    title:"软数信息科技研究院",
    meta: [
      { name:'viewport', content:
      `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
    ]
  },
  components: {
    LeftNews,
    MiddleNews,
    BottomNews,
    WebLinks,
    FootInfo,
    MidPicNews,
    RightNews,
    PicNews
  },
  props: {
    plates: Array,
    webConfigs: Object,
  },
  data() {
    return {
      ggw1picsrc: "",
      ggw2picsrc: "",
      ggw3picsrc: "",
      newplate: [
        {
          name: "公示公告",
        },
        {
          name: "工作动态",
        },
        {
          name: "信用资讯",
        },
        {
          name: "投标要素",
        },
      ],
      global,
      isPhone: global.isPhone(),
    };
  },
  mounted() {
    this.$axios.get("/api/advertises").then((res) => {
      let advs = [];
      if (res.data) {
        advs = res.data.data;
        for (let i = 0; i < advs.length; i++) {
          if (advs[i].position == "图片新闻下方广告") {
            this.ggw1picsrc = advs[i];
          } else if (advs[i].position == "图片栏目上方") {
            this.ggw2picsrc = advs[i];
          } else if (advs[i].position == "友情链接上方") {
            this.ggw3picsrc = advs[i];
          }
        }
      }
    });
  },
  methods: {
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  beforeDestroy() {
    this.toTop();
  },
};
</script>
<style scoped>
.centerimg {
  width: 381px;
height: 146px;
  margin-top: 20px;
  margin-bottom: 50px;
}
</style>
